// ── services/api/invites.api.ts ───────────────────────────────────────────────
// All /invites/* calls.
// ────────────────────────────────────────────────────────────────────────────

import { api } from './client';

export interface GeneratedInvite {
  token:     string;
  shareUrl:  string;
  nodeId:    string;
  treeId:    string;
  expiresAt: string;
}

export interface InviteInfo {
  nodeId:      string;
  treeId:      string;
  treeName?:   string;
  addedByName?: string;
  displayName: string;
  firstName:   string;
  lastName?:   string | null;
  dateOfBirth?: string | null;
  gender?:     string | null;
  avatarUrl?:  string | null;
  expiresAt?:  string;
}

export interface ClaimResult {
  nodeId:  string;
  treeId:  string;
  userId:  string;
  message: string;
}

export interface ReceivedInvite {
  nodeId:      string;
  treeId:      string;
  treeName?:   string;
  displayName: string;
  avatarUrl?:  string | null;
  addedByName?: string;
  token:       string;
  expiresAt:   string;
}

export const invitesApi = {
  /** Generate an invite link for a shadow node (admin only) */
  generate: (treeId: string, nodeId: string, invitedPhone?: string) =>
    api.post<GeneratedInvite>('/invites', { treeId, nodeId, ...(invitedPhone ? { invitedPhone } : {}) }),

  /** Invites addressed to my own phone number, across all trees */
  listReceived: () =>
    api.get<ReceivedInvite[]>('/invites/received'),

  /** Public preview of what an invite token points to */
  getInfo: (token: string) =>
    api.get<InviteInfo>(`/invites/${token}`),

  /** Claim the node behind an invite token (requires auth) */
  claim: (token: string) =>
    api.post<ClaimResult>(`/invites/${token}/claim`),

  /** Revoke a pending (unclaimed) invite (admin only) */
  revoke: (treeId: string, nodeId: string) =>
    api.delete<{ success: boolean }>(`/invites/${treeId}/${nodeId}`),
};
